module.exports = __webpack_public_path__ + "static/media/emptystate.a344bad6.svg";